import { REQUEST_SET_PRIVILEGES_MANAGER } from 'containers/ManagerManagement/constant';

export const requestSetPrivilegesManager = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_SET_PRIVILEGES_MANAGER,
    payload,
    successCallback,
  };
};
